<app-auth-layout>
  <form
    class="form-container"
    [class.fade]="isTransitioning"
    [formGroup]="signUpForm"
    (ngSubmit)="step() === steps.Welcome ? goToNextStep(isSso ? steps.Consent : steps.Pincode) : null"
  >
    @if (step() === steps.Welcome) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Welcome.Title' | translate: { firstname, lastname } }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Welcome.SubTitle' | translate }}</p>
      </div>

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.GetStarted' | translate"></app-button>
    }

    @if (step() === steps.Pincode) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Pincode.SetYourPincode' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Pincode.SubTitle' | translate }}</p>
      </div>

      <div class="error">
        {{ errorMessage ? (errorMessage | translate) : '' }}
      </div>

      <app-pin-code class="pin-code" (pinChanged)="updatePincode($event)"></app-pin-code>
    }

    @if (step() === steps.ConfirmPincode) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.ConfirmPincode.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.ConfirmPincode.SubTitle' | translate }}</p>
      </div>

      <div class="error">
        {{ errorMessage ? (errorMessage | translate) : '' }}
      </div>

      <app-pin-code class="pin-code" (pinChanged)="updatePincode($event)"></app-pin-code>

      <div class="actions">
        <div class="back" (click)="goToPincode()">
          <i class="fa-solid fa-chevron-left"></i>{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}
        </div>
      </div>
    }

    @if (step() === steps.Consent) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Consent.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Consent.SubTitle' | translate }}</p>
      </div>

      <div class="consent-container">
        <p class="text" [innerHTML]="terms"></p>
      </div>
      <app-button
        class="button"
        [label]="'WebApp.v1.Shared.Buttons.Accept' | translate"
        (click)="goToNextStep(steps.PersonalDetails)"
      ></app-button>
    }

    @if (step() === steps.PersonalDetails) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.SubTitle' | translate }}</p>
      </div>

      <div class="error">{{ signUpValidationError() | translate }}</div>

      <div class="input-container">
        <div class="row">
          <input
            class="input"
            formControlName="firstname"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.FirstName' | translate }}"
          >
          <input
            class="input"
            formControlName="lastname"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.LastName' | translate }}"
          >
        </div>
        <div class="row">
          <input
            class="input"
            formControlName="email"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.Email' | translate }}"
          >
        </div>
        <div class="row phone">
            <app-phone-input formControlName="phone" (dropdownOpenChange)="dropdownOpen = $event"></app-phone-input>
          </div>  
      </div>
      <app-button
        class="button"
        [class.hidden]="dropdownOpen"
        [label]="'WebApp.v1.Shared.Buttons.Complete' | translate"
        (click)="completeSignup()"
      ></app-button>
    }

    @if (step() === steps.SsoLinking) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Security.Text' | translate: { companyName: companyName() } }}</p>
        <p class="sub-title margin">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Continue.Text' | translate: { companyName: companyName() } }}</p>
      </div>

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Continue' | translate" (click)="continueToSsoPage()"></app-button>
    }
  </form>
</app-auth-layout>
